import { Account, Integration, OrgRef, UserRef, Vendor } from "@/viaduct-api";
import { createContext, useContext } from "react";

interface EntityImageContextType {
  findUserImage: (user: UserRef) => Promise<string | undefined>;
  findOrgImage: (org: OrgRef) => Promise<string | undefined>;
  findAccountImage: (account: Account) => Promise<string | undefined>;
  findVendorImage: (vendor: Vendor) => Promise<string | undefined>;
  findIntegrationImage: (
    integration: Integration,
  ) => Promise<string | undefined>;
}

export const EntityImageContext = createContext<EntityImageContextType>({
  findUserImage: () => Promise.resolve(undefined),
  findOrgImage: () => Promise.resolve(undefined),
  findAccountImage: () => Promise.resolve(undefined),
  findVendorImage: () => Promise.resolve(undefined),
  findIntegrationImage: () => Promise.resolve(undefined),
});

export const useEntityImages = () => useContext(EntityImageContext);
